<app-shared-dialog [options]="{
  confirmText: 'common.confirm' | translate,
  confirmIcon: 'arrow-right',
  confirmIconPosition: 'end',
  cancelText: 'common.cancel' | translate,
  size: 'large',
  hideHeader: true,
  customConfirmButton: true
}"
  (cancel)="cancel()"
  class="handling-units-dialog">
  <div class="dialog-header">
    <div class="header-left">
      <mat-icon class="header-icon">inventory_2</mat-icon>
      <div class="header-titles">
        <h2 *ngIf="!isEditMode">{{ "inventory.inventory_tab.handling_unit.title_add" | translate }}</h2>
        <h2 *ngIf="isEditMode">{{ "inventory.inventory_tab.handling_unit.title_edit" | translate }}</h2>
        <p class="header-sub" *ngIf="!isEditMode">{{ "inventory.inventory_tab.handling_unit.dialog_subtitle_add" | translate }}</p>
        <p class="header-sub" *ngIf="isEditMode">{{ "inventory.inventory_tab.handling_unit.dialog_subtitle_edit" | translate }}</p>
      </div>
    </div>
    <ui-button
      type="transparent"
      class="close-btn"
      icon="close"
      iconSize="large"
      (click)="cancel()"
    ></ui-button>
  </div>

  <div class="dialog-description" *ngIf="!isEditMode">
    <p>{{ "inventory.inventory_tab.handling_unit.description_add_line1" | translate }}</p>
    <p>{{ "inventory.inventory_tab.handling_unit.description_add_line2" | translate }}</p>
  </div>
  <div class="dialog-description" *ngIf="isEditMode">
    <p>{{ "inventory.inventory_tab.handling_unit.description_edit_line1" | translate }}</p>
    <p>{{ "inventory.inventory_tab.handling_unit.description_edit_line2" | translate }}</p>
  </div>

  <div class="dialog-content">
    <form class="information-form" [formGroup]="handlingUnitsForm">
      <div class="units-stack" formArrayName="units">
        <div
          *ngFor="let unit of units.controls; let i = index"
          [formGroupName]="i"
          class="selling-unit-card"
        >
          <div class="card-top">
            <div class="card-title-row">
              <span class="card-index" *ngIf="!isEditMode">{{ "inventory.inventory_tab.handling_unit.new_selling_unit_n" | translate: { n: i + 1 } }}</span>
              <span class="card-index" *ngIf="isEditMode">{{ "inventory.inventory_tab.handling_unit.editing_selling_unit" | translate }}</span>
              <button
                type="button"
                class="advanced-toggle"
                (click)="toggleAdvanced(i)"
                [class.advanced-toggle--on]="isAdvancedOpen(i)"
                [matTooltip]="'inventory.inventory_tab.handling_unit.advanced_developer_tooltip' | translate"
                matTooltipPosition="above"
                [attr.aria-expanded]="isAdvancedOpen(i)"
              >
                <mat-icon>developer_mode</mat-icon>
              </button>
            </div>

            <div class="card-fields card-fields--primary">
              <div class="standard-input">
                <label [for]="'name-' + i">{{ "inventory.inventory_tab.handling_unit.name" | translate }}</label>
                <input
                  type="text"
                  [id]="'name-' + i"
                  formControlName="name"
                  [matAutocomplete]="autoHu"
                />
                <mat-autocomplete #autoHu="matAutocomplete" (optionSelected)="onHandlingUnitTypeSelected($event.option.value, i)">
                  <ng-container *ngIf="getFilteredHandlingUnitTypes(i) | async as types">
                    <mat-option *ngFor="let type of types" [value]="type">
                      {{ type.name }}
                    </mat-option>
                    <ng-container *appHasPermission="{ module: 'product', action: 'create' }">
                      <mat-option
                        [value]="unit.get('name')?.value"
                        class="add_option"
                        *ngIf="types.length === 0 && unit.get('name')?.value"
                        (click)="addNewHandlingUnitType(unit.get('name')?.value, i)">
                        <img src="assets/icones/add.svg" alt="">
                        {{"common.add"|translate}} "{{ unit.get('name')?.value }}"
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </mat-autocomplete>
                <div
                  class="error"
                  *ngIf="
                    unit.get('name')?.invalid &&
                    (unit.get('name')?.touched || unit.get('name')?.dirty)
                  "
                >
                  <small *ngIf="unit.get('name')?.hasError('required')">{{
                    "common.required_field" | translate
                  }}</small>
                  <small *ngIf="unit.get('name')?.hasError('erpManagedType')">{{
                    "inventory.inventory_tab.handling_unit.erp_managed_type_blocked" | translate
                  }}</small>
                </div>
              </div>

              <div class="standard-input">
                <label [for]="'quantity-' + i">{{ "inventory.inventory_tab.handling_unit.quantity" | translate }}</label>
                <input
                  type="number"
                  [id]="'quantity-' + i"
                  formControlName="quantity"
                  min="0"
                  step="any"
                />
                <div
                  class="error"
                  *ngIf="
                    unit.get('quantity')?.invalid &&
                    (unit.get('quantity')?.touched || unit.get('quantity')?.dirty)
                  "
                >
                  <small *ngIf="unit.get('quantity')?.hasError('required')">{{
                    "common.required_field" | translate
                  }}</small>
                  <small *ngIf="unit.get('quantity')?.hasError('positiveQuantity')">{{
                    "inventory.validation.unit_quantity.positive" | translate
                  }}</small>
                </div>
              </div>

              <div class="standard-input dimensions-field">
                <label [for]="'dimensions-' + i">
                  {{ "inventory.inventory_tab.handling_unit.dimenssions" | translate }}
                  <span class="optional">({{ "common.optional" | translate }})</span>
                </label>
                <input
                  type="text"
                  [id]="'dimensions-' + i"
                  formControlName="dimensions"
                  placeholder="L × W × H"
                />
              </div>

              <ng-container *appHasPermission="submitPermission()">
                <button type="button" class="delete-btn" (click)="removeUnit(i)" *ngIf="units.length > 1 && !isEditMode" [attr.aria-label]="'common.delete' | translate">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>

          <div class="card-advanced" *ngIf="isAdvancedOpen(i)">
            <div class="advanced-heading">{{ "inventory.inventory_tab.handling_unit.advanced_section_title" | translate }}</div>
            <p class="advanced-intro">{{ "inventory.inventory_tab.handling_unit.advanced_section_intro" | translate }}</p>

            <div class="advanced-grid">
              <div class="standard-input">
                <label [for]="'rounding-mode-' + i">{{ "inventory.inventory_tab.handling_unit.rounding_mode" | translate }}</label>
                <mat-select [id]="'rounding-mode-' + i" formControlName="rounding_mode">
                  <mat-option *ngFor="let m of roundingModes" [value]="m">{{ m }}</mat-option>
                </mat-select>
              </div>

              <div class="standard-input">
                <label [for]="'rounding-decimals-' + i">{{ "inventory.inventory_tab.handling_unit.rounding_decimals" | translate }}</label>
                <input
                  type="number"
                  [id]="'rounding-decimals-' + i"
                  formControlName="rounding_decimals"
                  min="0"
                  step="1"
                />
              </div>

              <div class="standard-input">
                <label [for]="'mult-' + i">{{ "inventory.inventory_tab.handling_unit.multiplier_override" | translate }}</label>
                <input
                  type="number"
                  [id]="'mult-' + i"
                  formControlName="multiplier_from_base_unit"
                  min="0"
                  step="any"
                  [placeholder]="'inventory.inventory_tab.handling_unit.multiplier_placeholder' | translate"
                />
              </div>

              <div class="rounding-mode-info" *ngIf="unit.get('rounding_mode')?.value as rm" role="note" [attr.aria-label]="rm">
                <mat-icon class="rounding-mode-info__icon">info_outline</mat-icon>
                <div class="rounding-mode-info__text">
                  <p class="rounding-mode-info__summary">{{ roundingModeHelpKey(rm, 'summary') | translate }}</p>
                  <p class="rounding-mode-info__example">
                    <span>{{ "inventory.inventory_tab.handling_unit.rounding_help.example_label" | translate }}</span>
                    {{ roundingModeHelpKey(rm, 'example') | translate }}
                  </p>
                </div>
              </div>

              <div class="standard-input">
                <label [for]="'qmin-' + i">{{ "inventory.inventory_tab.handling_unit.qty_min" | translate }}</label>
                <input type="number" [id]="'qmin-' + i" formControlName="qty_min" step="any" />
              </div>

              <div class="standard-input">
                <label [for]="'qmax-' + i">{{ "inventory.inventory_tab.handling_unit.qty_max" | translate }}</label>
                <input type="number" [id]="'qmax-' + i" formControlName="qty_max" step="any" />
              </div>

              <div class="standard-input">
                <label [for]="'qinc-' + i">{{ "inventory.inventory_tab.handling_unit.qty_increment" | translate }}</label>
                <input type="number" [id]="'qinc-' + i" formControlName="qty_increment" step="any" />
              </div>

              <div class="toggle-field toggle-field--inline">
                <mat-slide-toggle formControlName="is_continuous" color="primary">
                  {{ "inventory.inventory_tab.handling_unit.flag_continuous" | translate }}
                </mat-slide-toggle>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *appHasPermission="submitPermission()">
        <button type="button" class="add-btn" *ngIf="!isEditMode" (click)="addUnit()">
          <mat-icon>add</mat-icon>
          <span>{{ "inventory.inventory_tab.handling_unit.add_selling_unit" | translate }}</span>
        </button>
      </ng-container>
    </form>
  </div>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="'common.confirm' | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
